/**
 * Splits a CSS "style" attribute value into individual declarations. Unlike a naive
 * `split(";")`, this ignores semicolons that appear inside parentheses (e.g. a
 * `background-image: url(data:image/png;base64,...)` data URI), so such values aren't
 * corrupted.
 *
 * @param style - The value of a CSS "style" attribute, e.g. `color:#000000; text-align:center`
 *
 * @returns An array of individual CSS declarations, e.g. `["color:#000000", "text-align:center"]`
 */
export const splitStyleDeclarations = (style: string): string[] => {
  const declarations: string[] = [];
  let depth = 0;
  let current = "";

  for (const char of style) {
    if (char === "(") depth++;
    if (char === ")") depth--;

    if (char === ";" && depth <= 0) {
      declarations.push(current);
      current = "";
    } else {
      current += char;
    }
  }
  declarations.push(current);

  return declarations
    .map((decl) => decl.trim())
    .filter((decl) => decl.length > 0);
};
